import { css } from '@emotion/react';
import { FlexStyle } from 'styles/FlexStyles';
import { PaddingStyle } from 'styles/PaddingStyle';
import { Spinner } from './Spinner';
import { theme } from 'styles/theme';

export const SpinnerBlock = ({ v }: { v?: number }) => {
	return (
		<div
			css={[
				FlexStyle({ justifyContentCenter: true }),
				PaddingStyle({ v: v ?? 40 }),
				css`
					color: ${theme.color.primary[400]};
				`,
			]}
		>
			<Spinner />
		</div>
	);
};
